import { render, staticRenderFns } from "./SettingsDialog.vue?vue&type=template&id=2f858a20&scoped=true"
import script from "./SettingsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SettingsDialog.vue?vue&type=style&index=0&id=2f858a20&prod&scoped=true&lang=css"
import style1 from "./SettingsDialog.vue?vue&type=style&index=1&id=2f858a20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f858a20",
  null
  
)

export default component.exports